module.exports = __webpack_public_path__ + "img/36.3aea4863.png";